define(
  'SuiteCommerce.ItemBadges.Instrumentation.InstrumentationHelper',
  [
    'SuiteCommerce.ItemBadges.Instrumentation.Model',
    'SuiteCommerce.ItemBadges.Instrumentation.Collection',
    'SuiteCommerce.ItemBadges.Instrumentation.Logger'
  ],
  function define(
    Log,
    LogCollection,
    Logger
  ) {
    'use strict';

    var logs = new LogCollection();

    return {
      logs: logs,

      initialize: function initialize(container) {
        Logger.initialize(container.getComponent('Environment'));
      },

      getLog: function getLog(logLabel) {
        return this.getLogModelByLabel(logLabel) || this.registerNewLog(logLabel);
      },

      getLogModelByLabel: function getLogModelByLabel(label) {
        return this.logs.findWhere({
          label: label
        });
      },

      registerNewLog: function registerNewLog(label) {
        var log = new Log();
        log.set('label', label);
        this.logs.add(log);
        return log;
      },

      setParameterToSubmitForAllLogs: function setParameterToSubmitForAllLogs(parameter, value) {
        this.logs.each(function updateLog(log) {
          log.setParameterToSubmit(parameter, value);
        });
      },

      setParametersToSubmitForAllLogs: function setParametersToSubmitForAllLogs(data) {
        this.logs.each(function updateLog(log) {
          log.setParametersToSubmit(data);
        });
      },

      submitAllLogs: function submitAllLogs() {
        this.logs.each(function submitLog(log) {
          log.submit();
        });
      }
    };
  }
);
